<template>
  <el-dialog :close-on-click-modal="false" class="tx-c" :visible="visible" append-to-body :title="title" @close="cancel" width="50rem" top="10vh">
    <el-main style="padding: 0 10px; height: 31rem">
      <hic-ip-patient-selector :patient="patient" />
      <div>
        <el-row type="flex" style="padding:0 20%;">
            <el-col>
              <el-select class="" v-model="card.cardType" placeholder="请选择证件类型" size="small">
                <!-- <el-option v-for="(item, index) in getDict('IdType')" :key="index" :label="item.text" :value="item.code"></el-option> -->
                <el-option v-for="(item, index) in cards" :key="index" :label="item.text" :value="item.code"></el-option>
                <!-- <el-option v-for="(item, index) in [{text:'住院号',code:'ipNo'},{text:'身份证',code:'SF'},{text:'港澳通行证',code:'GA'},{text:'未知',code:'WZ'}]" :key="index" :label="item.text" :value="item.code"></el-option> -->
              </el-select>
            </el-col>
            <el-col>
              <el-input class="condition-wide left-pad" v-model="card.cardNo" placeholder="请输入号码" size="small" v-on:keyup.enter.native="queryPatient" clearable>
                <el-button  type="info" :loading="meta.loading" slot="append" icon="el-icon-search" @click="queryPatient"></el-button>
              </el-input>
            </el-col>
            <el-col style="">
              <el-button type="info" size="small">身份证读卡</el-button>
            </el-col>
          </el-row>
      </div>
      <br/>
      <div v-if="meta.content" v-loading="meta.loading">
        <div class="" style="padding:10px 40px;">
          <el-descriptions title="患者信息" :column="4" :colon="false">
            <el-descriptions-item label="姓名：">{{patient.patientName}}</el-descriptions-item>
            <el-descriptions-item label="性别：">{{patient.patientGender | dictText("Gender")}}</el-descriptions-item>
            <el-descriptions-item label="年龄：">{{patient.patientAge}}岁</el-descriptions-item>
            <el-descriptions-item label="医保类型：">{{patient.ipType}}</el-descriptions-item>
            <el-descriptions-item v-if="title=='交预交金'" :span="2" label="预交金总额：">{{patient.advanceFeeTotal || 0}}元 <span style="color:#409EFF;padding-left:10px;" @click="lookHistory">查看详情</span></el-descriptions-item>
            <el-descriptions-item v-if="title=='交预交金'" label="记账金额：">{{patient.bookkeepingFeeTotal || 0}}元</el-descriptions-item>

          </el-descriptions>
          <el-divider></el-divider>
          <el-descriptions :title="title"></el-descriptions>
          
          <el-form class="left" ref="info" :rules="rules" :inline="true" :model="detailValue" label-width="8rem">
            <el-row v-if="title=='交预交金'">
              <el-col :span="12">
                <el-form-item label="预交金额：" prop="amount">
                  <el-input type="text" maxlength="6" v-model="detailValue.amount" placeholder="请输入预交金额" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收款方式：" prop="payWay">
                  <el-select class="" v-model="detailValue.payWay" placeholder="请选择收款方式" size="small">
                    <el-option v-for="(item, index) in dict.PayWay" :key="index" :label="item.text" :value="item.code"></el-option>
                    <!-- <el-option v-for="(item, index) in [{text:'微信',code:'WX'},{text:'支票',code:'ZP'}]" :key="index" :label="item.text" :value="item.code"></el-option> -->
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="detailValue.payWay =='ZP'">
                <el-form-item label="支票号：" prop="zpNo">
                  <el-input v-model="detailValue.zpNo" type="number" placeholder="请输入支票号" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="detailValue.payWay =='ZP'">
                <el-form-item label="开户行：" prop="zpBank">
                 <el-input v-model="detailValue.zpBank" type="number" placeholder="请输入开户行" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
               <el-col :span="12">
                <el-form-item label="交款人：" prop="payerName">
                 <el-input v-model="detailValue.payerName" maxlength="10" placeholder="请输入交款人" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式：" prop="payerPhone">
                  <el-input v-model="detailValue.payerPhone" placeholder="请输入交款人联系方式" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="批准人：" prop="">
                  <el-input v-model="detailValue.pzPerson" maxlength="10" placeholder="请输入批准人" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="title=='欠账申请'">
              <!-- <el-col :span="24">
                <el-form-item label="不交押金：" prop="">
                  <el-checkbox v-model="checkedQZ"></el-checkbox>
                </el-form-item>
              </el-col> -->
              <el-col v-if="!checkedQZ" :span="12">
                <el-form-item label="欠账额度：" prop="qzAmount">
                  <el-input v-model="detailValue.qzAmount" maxlength="6"  placeholder="请输入可欠账额度" size="small" clearable></el-input>
                </el-form-item>
              </el-col>
              
               <el-col v-if="!checkedQZ" :span="12">
                <el-form-item label="欠账截止日期：" prop="qzEndDate">
                  <el-date-picker size="small" style="width:210px;" v-model="detailValue.qzEndDate" type="date" placeholder="请选择欠账截止日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注：" prop="">
                  <el-input type="textarea" style="width:30rem;" maxlength="500" show-word-limit :autosize="{ minRows: 3, maxRows: 4}" placeholder="请输入备注" v-model="detailValue.memo">
                </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <el-row style="margin-top: 20px; text-align: right">
            <el-button size="large" @click.native="$emit('update:visible', false)" class="w100">关闭</el-button>
            <el-button v-if="title=='欠账申请'" size="large" @click.native="submit('save')" class="w100">保存</el-button>
            <el-button :loading="meta.loading" class="w100" @click="submit" type="primary" style="margin-left: 1rem" size="large">提交</el-button>
            <br/>
            <br/>
            <el-checkbox v-if="title=='交预交金'" v-model="checked">打印凭据</el-checkbox>
        </el-row>
        <br>
      </div>
      <!-- <el-empty v-else description="暂无数据"></el-empty> -->
      
    </el-main>
    <operation :info="patient" v-if="meta.showOper" title="预交金记录" :visible.sync="meta.showOper"></operation>
    <payment :infoDetail="payParams" v-if="meta.showPayment" :visible.sync="meta.showPayment" @closePay="$emit('update:visible', false)"></payment>
  </el-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";

export default {
  components: {
    operation: () => import("./operation"),
    payment: () => import("@/components/_com/payment.vue"),
  },
  props: {
    title:String,
    infoDetail:Object,
    visible: Boolean,
    isNew: Boolean,
  },
  data() {
    var checkFloat = (rule, value, callback) => {
      let frex = /^[0-9]+\.?[0-9]*$/;
      if (!value) return callback();
      if (!frex.test(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    
    var ValidatePhone = (rule, val, callback) => {
      var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;//手机号码
      var isMob= /^0?1[3|4|5|8][0-9]\d{8}$/;// 座机格式  区号之后用'-'隔开
      if(isMob.test(val)||isPhone.test(val)){
          callback();
      }
      else{
          callback(new Error("请输入正确的联系方式"));
      }
    }

    return {
      patient:{},
      checkedQZ:false,
      checked:false,
      detailValue:{},
      rules: {
        amount: [
          { required: true, message: "请输入预交金额", trigger: "blur" },
          { validator: checkFloat, trigger: "blur" }],
        payWay: [
          { required: true, message: "请选择支付方式", trigger: "change" },
        ],
        zpNo: [{ required: true, message: "请输入支票号", trigger: "blur" }],
        zpBank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        payerName: [{ required: true, message: "请输入交款人", trigger: "blur" }],
        payerPhone: [
          { required: true, message: "请输入交款人联系方式", trigger: "blur" },
          { validator: ValidatePhone, trigger: "blur" }
        ],
        qzAmount:[{ required: true, message: "请输入可欠账额度", trigger: "blur" },
        { validator: checkFloat, trigger: "blur" }],
        qzEndDate:[{ required: true, message: "请选择欠账截止日期", trigger: "change" }]
      },
      card:{
        cardType:'ipNo',
        cardNo:'ip0000001' //
      },
      meta:{
        loading:false,
        showOper:false,
        content:false,
        showPayment:false
      },
      reason:'',
      payParams:{}
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum","user", "permission"]),
    cards() {
      let arr = this.dict.IdType
      // arr.push()
      // console.log('s==',this.getDict('IdType'))
      return [{'text':'住院号','code':'ipNo'}].concat(arr)
    },
  },
  filters:{
   
  },
  watch:{
  },
  mounted() {
   
    // this.meta.loading = true;
    // this.getPatient()
    // this.getAllPayList()
  },
  methods: {
    async queryPatient(){
      try {
        this.meta.loading = true
        let _ipNo = ''
        if(this.card.cardType !== 'ipNo'){
          let patient = await api.getPatientByIdNo(this.card.cardNo,this.card.cardType)
          let params = {
            patientCode:patient.code
          }
          let admission = await api.getAdmission(params)
          if(admission && admission.items && admission.items.length>0){
            let _adm = admission.items[0]
            _ipNo = _adm.ipNo
          }else{
            return this.$message.error('没查询到用户信息')
          }
        }else{
        _ipNo =this.card.cardNo
        }


        let patientMoney = await api.getPatientMoney(_ipNo)
        if(patientMoney){
          this.patient = patientMoney
          this.meta.content = true
        }else{
          this.$message.error('没查询到用户信息')
        }
      } catch (error) {
        console.log('error:',error)
        this.$message.error(error)

      }
      
      this.meta.loading = false
      
    },
    lookHistory(){
      this.meta.showOper = true
    },
    
    genderFlter(v){
      let info = this.dict.Gender.find((item)=>{
        return v == item.code
      })
      return ''
    },
    submit(type){
      this.$refs.info.validate((valid) => {
        if (valid) {
          
          if(this.title == '交预交金'){
            let params = {
              ipNo:this.patient.ipNo,
              patientCode:this.patient.patientCode,
              patientName:this.patient.patientName,
              amount:this.detailValue.amount,
              payWay:this.detailValue.payWay,
              payerName:this.detailValue.payerName,
              payerPhone:this.detailValue.payerPhone,
              paymentType:0,//0-收费，1-退费
              occasion:0,//0-入院缴费、1-在院补缴、2-离院补缴，3-离院退费

              paymentId:1,
              paymentDate:'2022-06-22 12:00:00',
              printCheck:this.checked
            }
            this.payParams = params
            this.meta.showPayment = true
            // api.addDeposit(params).then((res)=>{
            //   console.log('返回数据：',res)
            //   this.$emit("close");
            //   if(this.checked){
            //     return this.addCounts(res.id)
            //   }
            //   this.meta.loading = false;
            //   this.$message.success("交费成功")
            //   this.cancel()
            // }).catch((err)=>{
            //   this.$message.error(err.message || err);
            // }).finally(()=>{
              
            // }) 
          }
          if(this.title == '欠账申请'){
            this.meta.loading = true
            let params = {
              patientCode:this.patient.patientCode,
              ipNo:this.patient.ipNo,
              amount:this.detailValue.qzAmount,
              endDate: this.$utils.Dt.fmtDateTime(this.detailValue.qzEndDate),
              state:(type == 'save')?0:1, //草稿、审批中、通过、拒绝
              proposerId:this.user.id,
              proposerName:this.user.name,
              proposeTime:this.$utils.Dt.fmtDateTime(new Date().getTime()),
              proposeReason:this.detailValue.memo
            }

            api.addArrearage(params).then((res)=>{
              console.log('返回数据：',res)
              this.$emit("close");
              
              this.meta.loading = false;
              this.$message.success("申请成功")
              this.cancel()
            }).catch((err)=>{
              this.$message.error(err.message || err);
            }).finally(()=>{
              
            })
          }
         
        } else {
          console.log("error submit!!");
          return false;
        }
      })
      console.log('detailValue==>',this.detailValue)
      return
    },
    
    addCounts(id){
      api.paymentCounts(id).then(res=>{
        this.$message.success("交费成功")
        this.cancel()
      }).catch(error=>{

      }).finally(()=>{
        this.meta.loading = false;
      })
    },
    cancel() {
      this.$emit("update:visible", false);
    },
    addFloat(num1, num2){
      num1 = parseFloat(num1).toFixed(2)
      num2 = parseFloat(num2).toFixed(2)
      let r1, r2, m;
      r1 = (''+num1).split('.')[1].length;
      r2 = (''+num2).split('.')[1].length;

      m = Math.pow(10,Math.max(r1,r2));
      return (num1 * m + num2 * m) / m;
    }
  },
  beforeRouteLeave (to,from, next) {
    return next();
  }
};
</script>

<style scoped>
.redaK{
  background-color: #909399;
}
.tx-r{
  text-align: right;
}

.tx-l{
  text-align: left;
}
.tx-c{
  text-align: center;
}
.pall10p{
  padding: 10px;
}


.patientBox {
  height: 5rem;
  margin-bottom: 2rem;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.ztitle {
  margin-top: 10px;
  color: #66b1ff;
}
.inputnw .el-input {
  width: 4rem !important;
}
.inputDelW {
  width: 12rem;
}
.el-form--inline .el-form-item{
  margin-right: 0px;
}

</style>
